<ng-container *ngIf="vo$ | async; let vo">
	<app-exposition-consumers-mapping
		[consumersToMap]="vo.consumersToMap"
		(activateAutoMapping)="autoMappingAction($event)"
		(resetEligibleConsumers)="resetEligibleConsumersAction()"
		(reloadUsers)="reloadUsers()"
		(assignTargetConsumer)="
			assignTargetConsumer($event)
		"></app-exposition-consumers-mapping>
</ng-container>
